var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-me"},[_c('prime-title',{attrs:{"title":"关于我"}}),_vm._l((_vm.contents),function(content,index){return _c('p',{key:index,domProps:{"innerHTML":_vm._s(content)}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }